import styled from 'styled-components';
import { Typography } from '@mui/material';

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primaryLight};
  font-size: 0.875rem;
  font-style: normal;
  margin-bottom: 0.5em;
`;
